import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { heroiconsWarning, heroiconsXCircle } from '@ld.consumer-portal/data-uri';
import { SvgIconComponent } from '@ld.consumer-portal/ui-shared';
import { PlatformService } from '@ld.consumer-portal/utils';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-unsaved-changes-modal',
  imports: [BaseModalComponent, SvgIconComponent, TranslocoDirective],
  templateUrl: './unsaved-changes-modal.component.html',
  styleUrl: './unsaved-changes-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnsavedChangesModalComponent {
  private readonly platformService = inject(PlatformService);

  protected readonly isBottomSheet = computed(() => this.platformService.isNativeMobile());
  protected readonly heroiconsWarning = heroiconsWarning;
  protected readonly closeIcon = heroiconsXCircle;

  isOpen = input<boolean>(false);

  type = input<'leave-page' | 'confirm-not-saved'>('leave-page');

  customTitle = input<string | null>(null);

  customMessage = input<string | null>(null);

  customStayButtonLabel = input<string | null>(null);

  customLeaveButtonLabel = input<string | null>(null);

  stayOnPage = output<void>();

  leavePage = output<void>();

  protected get titleKey(): string {
    switch (this.type()) {
      case 'confirm-not-saved':
        return 'modalsUnsavedChangesConfirmNotSavedTitle';
      case 'leave-page':
      default:
        return 'modalsUnsavedChangesLeavePageTitle';
    }
  }

  protected get messageKey(): string {
    switch (this.type()) {
      case 'confirm-not-saved':
        return 'modalsUnsavedChangesConfirmNotSavedMessage';
      case 'leave-page':
      default:
        return 'modalsUnsavedChangesLeavePageMessage';
    }
  }

  protected get stayButtonKey(): string {
    switch (this.type()) {
      case 'confirm-not-saved':
        return 'modalsUnsavedChangesConfirmNotSavedStayButton';
      case 'leave-page':
      default:
        return 'modalsUnsavedChangesLeavePageStayButton';
    }
  }

  protected get leaveButtonKey(): string {
    switch (this.type()) {
      case 'confirm-not-saved':
        return 'modalsUnsavedChangesConfirmNotSavedLeaveButton';
      case 'leave-page':
      default:
        return 'modalsUnsavedChangesLeavePageLeaveButton';
    }
  }

  protected onStayClick(): void {
    this.stayOnPage.emit();
  }

  protected onLeaveClick(): void {
    this.leavePage.emit();
  }

  protected onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.stayOnPage.emit();
    }
  }
}
